














import { Component, Mixins } from 'vue-property-decorator'
import CookieConsentMixin from '../mixins/CookieConsentMixin'

@Component
export default class CookieConsent extends Mixins(CookieConsentMixin) {
  acceptVideo () {
    this.changeValues([{ key: 'socials', value: true }])
    this.update('cookie-consent-video')
  }
}
